// AccordionItem.tsx
import React, { useState } from 'react';
import { AccordionItemWrapper, AccordionTrigger, AccordionContentWrapper, AccordionContentInner } from './AccordionStyles';

interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
}

const AccordionItem: React.FC<AccordionItemProps> = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <AccordionItemWrapper>
      <AccordionTrigger
        onClick={toggleOpen}
        $isOpen={isOpen}
        aria-expanded={isOpen}
      >
        {title}
      </AccordionTrigger>
      <AccordionContentWrapper $isOpen={isOpen}>
        <AccordionContentInner>
          {children}
        </AccordionContentInner>
      </AccordionContentWrapper>
    </AccordionItemWrapper>
  );
};

export default AccordionItem;
